import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { formValueSelector } from 'redux-form';

import { LoadingPage } from 'Components';
import { setNotificationDialog } from 'Components/dialogs/state/actions';
import { errorToast, toastSuccess } from 'Common/ToastHelper';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';
import { CREATE_EDIT_TRUCK_ROUTE_FORM_NAME } from 'Common/FormEnum';
import { submitForm, resetForm } from 'State/forms/actions';
import { getSitesAction } from 'State/sites/actions';
import * as FilterSelector from 'State/filters/selectors';
import { resetDirty } from 'State/dirtyTracking/actions';
import {
  BidGroupEnum,
  CreateEditTruckRouteEnum,
  ItemEnum,
} from 'Common/FieldEnum';
import {
  GenericEnum,
  CreateEditPageEnum,
} from 'Common/Constants/Enumeration/CommonEnum';
import {
  TruckRouteTypeEnum,
  AssignTypeEnum,
} from 'Common/Constants/Enumeration/TruckRouteEnum';
import {
  getAcctCategoryForCurrentSite,
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getStorageLocationForCurrentSite,
  getVendorForCurrentSite,
  getSiteGroupDataForCurrentSite,
  clearFilterErrorMsg,
} from 'State/filters/actions';

import {
  getSiteItemsBySiteIds,
  clearErrors,
  saveTruckRoute,
  clearSiteItems,
  clearSavedMessage,
  getTruckRouteById,
  clearSiteItemsMessage,
  getItemsByDistributorIds,
  getTruckRouteAssignmentTypes,
  getTruckRouteTypes,
} from './../state/createedittruckroute/actions';
import * as Selectors from './../state/createedittruckroute/selectors';

import { CreateEditTruckRoute } from './../../truckroutes/containers/createedittruckroute/CreateEditTruckRoute';
import { BASE_URL } from './../helper/index';

class CreateEditTruckRoutePageContainer extends Component {
  static path = `${BASE_URL}/route/:isNewEdit/:id`;
  static propTypes = {
    isDirty: PropTypes.bool.isRequired,
    fetchingDropdown: PropTypes.bool.isRequired,
    bidGroupData: PropTypes.array.isRequired,
    itemGroupData: PropTypes.array.isRequired,
    acctCategoryData: PropTypes.array.isRequired,
    vendorData: PropTypes.array.isRequired,
    storageLocationData: PropTypes.array.isRequired,
    bidGroupDataError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    itemGroupDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    acctCategoryDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    vendorDataError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    storageLocationDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    siteGroupLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    siteData: PropTypes.array.isRequired,
    siteItems: PropTypes.array.isRequired,
    siteItemsMessage: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    siteItemsLoading: PropTypes.bool.isRequired,
    siteItemsLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    initialSelectedSites: PropTypes.array.isRequired,
    initialSelectedVendors: PropTypes.array.isRequired,
    saving: PropTypes.bool.isRequired,
    saveError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    saved: PropTypes.string,
    resetDirty: PropTypes.func.isRequired,
    getBidGroupForCurrentSite: PropTypes.func.isRequired,
    getItemGroupForCurrentSite: PropTypes.func.isRequired,
    getAcctCategoryForCurrentSite: PropTypes.func.isRequired,
    getVendorForCurrentSite: PropTypes.func.isRequired,
    getStorageLocationForCurrentSite: PropTypes.func.isRequired,
    getSiteGroupDataForCurrentSite: PropTypes.func.isRequired,
    getSiteItemsBySiteIds: PropTypes.func.isRequired,
    submitForm: PropTypes.func.isRequired,
    clearErrors: PropTypes.func.isRequired,
    clearFilterErrorMsg: PropTypes.func.isRequired,
    saveTruckRoute: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    clearSiteItems: PropTypes.func.isRequired,
    clearSavedMessage: PropTypes.func.isRequired,
    selectedTruckRouteDetailLoading: PropTypes.bool.isRequired,
    selectedTruckRouteDetail: PropTypes.object,
    selectedTruckRouteDetailError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    truckRouteType: PropTypes.number,
    assignType: PropTypes.number,
    vendorTableData: PropTypes.array.isRequired,
    vendorTableDataLoading: PropTypes.bool.isRequired,
    vendorItemIdsLoading: PropTypes.bool.isRequired,
    vendorItemIdsLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    getTruckRouteById: PropTypes.func.isRequired,
    clearSiteItemsMessage: PropTypes.func.isRequired,
    setNotificationDialog: PropTypes.func.isRequired,
    getItemsByDistributorIds: PropTypes.func.isRequired,
    getTruckRouteAssignmentTypes: PropTypes.func.isRequired,
    getTruckRouteTypes: PropTypes.func.isRequired,

    truckRouteAssignmentTypesOptions: PropTypes.array.isRequired,
    truckRouteTypesOption: PropTypes.array.isRequired,
    truckRouteAssignmentTypesLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    truckRouteTypesLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
  };

  static defaultProps = {
    bidGroupDataError: null,
    itemGroupDataError: null,
    acctCategoryDataError: null,
    vendorDataError: null,
    storageLocationDataError: null,
    siteGroupLoadingError: null,
    siteItemsLoadingError: null,
    submitError: null,
    submit: null,
    selectedTruckRouteDetail: null,
    selectedTruckRouteDetailError: null,
    siteItemsMessage: null,
    truckRouteType: TruckRouteTypeEnum.Delivery,
    assignType: AssignTypeEnum.Sites,
    vendorItemIdsLoadingError: null,
    truckRouteAssignmentTypesLoadingError: null,
    truckRouteTypesLoadingError: null,
  };

  state = {
    isErrorPage: false,
  };
  async componentDidMount() {
    const { isNewEdit, id } = this.props.match.params;
    this.props.getBidGroupForCurrentSite(BidGroupEnum.UnassignedAndAll);
    this.props.getItemGroupForCurrentSite();
    this.props.getAcctCategoryForCurrentSite();
    this.props.getVendorForCurrentSite();
    this.props.getStorageLocationForCurrentSite();
    this.props.getSiteGroupDataForCurrentSite();
    this.props.getSitesAction();
    if (isNewEdit === CreateEditPageEnum.EDIT) {
      await this.props.getTruckRouteById(id);
      const { selectedTruckRouteDetail } = this.props;
      if (selectedTruckRouteDetail) {
        if (
          selectedTruckRouteDetail[CreateEditTruckRouteEnum.Type] !==
            TruckRouteTypeEnum.Delivery &&
          selectedTruckRouteDetail[CreateEditTruckRouteEnum.AssignmentType] ===
            AssignTypeEnum.Distributor
        ) {
          this.props.getItemsByDistributorIds({
            RouteId: id,
            DistributorIds:
              selectedTruckRouteDetail[CreateEditTruckRouteEnum.DistributorIds],
          });
        } else {
          this.props.getSiteItemsBySiteIds({
            RouteId: id,
            SiteIds: selectedTruckRouteDetail[CreateEditTruckRouteEnum.SiteIds],
          });
        }
      }
    }
    this.props.getTruckRouteAssignmentTypes();
    this.props.getTruckRouteTypes();
  }
  componentDidUpdate(prevProps) {
    const {
      clearFilterErrorMsg,
      saved,
      clearSavedMessage,
      clearErrors,
      clearSiteItemsMessage,
      setNotificationDialog,
      siteItemsMessage,
    } = this.props;
    if (
      errorToast(this.props, prevProps, 'bidGroupDataError') ||
      errorToast(this.props, prevProps, 'itemGroupDataError') ||
      errorToast(this.props, prevProps, 'acctCategoryDataError') ||
      errorToast(this.props, prevProps, 'vendorDataError') ||
      errorToast(this.props, prevProps, 'storageLocationDataError') ||
      errorToast(this.props, prevProps, 'siteGroupLoadingError')
    ) {
      clearFilterErrorMsg();
    }
    if (
      errorToast(this.props, prevProps, 'saveError') ||
      errorToast(this.props, prevProps, 'selectedTruckRouteDetailError') ||
      errorToast(
        this.props,
        prevProps,
        'truckRouteAssignmentTypesLoadingError'
      ) ||
      errorToast(this.props, prevProps, 'truckRouteTypesLoadingError')
    ) {
      if (
        prevProps.selectedTruckRouteDetailError !==
        this.props.selectedTruckRouteDetailError
      ) {
        this.setState({ isErrorPage: true });
      }
      clearErrors();
    }
    if (saved && saved !== prevProps.saved) {
      toastSuccess(saved);
      clearSavedMessage();
      this.props.resetDirty();
      this.redirectToRoutePageList();
    }
    if (siteItemsMessage && siteItemsMessage !== prevProps.siteItemsMessage) {
      const dialog = {
        ...NOTIFICATION_DIALOG_MESSAGES.CREATE_EDIT_TRUCK_ROUTE_SITE_ITEMS_VALIDATION,
        message: siteItemsMessage,
      };
      setNotificationDialog(dialog);
      clearSiteItemsMessage();
    }
  }
  componentWillUnmount() {
    this.props.resetForm(CREATE_EDIT_TRUCK_ROUTE_FORM_NAME);
    this.props.clearSiteItems();
    this.props.resetDirty();
  }

  getRootUrl = () => {
    return BASE_URL;
  };
  getBreadCrumbs = () => {
    const { isNewEdit } = this.props.match.params;
    let breadcrumbs = [
      {
        title: 'Truck Route Setup',
        link: BASE_URL,
      },
      {
        title:
          isNewEdit !== CreateEditPageEnum.EDIT
            ? 'Create New'
            : 'Edit Truck Route',
        link: '',
      },
    ];
    return breadcrumbs;
  };
  getMainProps = showDirtyConfirm => {
    let toolbox = {
      backButtonProps: { shown: true, path: this.getRootUrl() },
      rightButtons: [
        {
          content: 'Save',
          onClick: this.handleSave,
        },
      ],
      shown: true,
    };
    return {
      toolbox,
    };
  };
  handleSave = e => {
    this.props.submitForm(CREATE_EDIT_TRUCK_ROUTE_FORM_NAME);
  };
  handleSubmit = values => {
    const { saveTruckRoute, siteItems } = this.props;
    const { isNewEdit, id } = this.props.match.params;
    const valuesClone = _.clone(values);
    _.remove(valuesClone[CreateEditTruckRouteEnum.ItemIds], item => {
      return (
        _.findIndex(siteItems, siteItem => {
          return siteItem[ItemEnum.ItemId] === item;
        }) === -1
      );
    });
    const submitObj = {
      id: isNewEdit === CreateEditPageEnum.NEW ? 0 : id,
      routeName: valuesClone[CreateEditTruckRouteEnum.RouteName],
      Type: valuesClone[CreateEditTruckRouteEnum.Type],
      AssignmentType: valuesClone[CreateEditTruckRouteEnum.AssignType],
      DistributorIds: valuesClone[CreateEditTruckRouteEnum.VendorIds],
      siteIds: valuesClone[CreateEditTruckRouteEnum.SiteIds],
      itemIds: valuesClone[CreateEditTruckRouteEnum.ItemIds],
    };
    saveTruckRoute(submitObj);
  };
  redirectToRoutePageList = () => {
    this.props.history.push(BASE_URL);
  };
  getCreateEditTruckRoute = () => {
    const {
      bidGroupData,
      itemGroupData,
      acctCategoryData,
      vendorData,
      storageLocationData,
      siteGroupData,
      fetchingDropdown,
      siteData,
      initialSelectedSites,
      initialSelectedVendors,
      siteItems,
      siteItemsLoading,
      saving,
      selectedTruckRouteDetail,
      selectedTruckRouteDetailLoading,
      truckRouteType,
      assignType,
      vendorTableData,
      vendorItemIdsLoading,
      clearSiteItems,
      vendorTableDataLoading,
      truckRouteAssignmentTypesOptions,
      truckRouteTypesOption,
    } = this.props;
    const { isNewEdit, id } = this.props.match.params;
    let routeName = '';
    let initialValues = {};
    let render = false;
    if (isNewEdit === CreateEditPageEnum.NEW || this.state.isErrorPage) {
      initialValues = {
        [CreateEditTruckRouteEnum.SiteGroupId]: GenericEnum.InitialFilterValue,
        [CreateEditTruckRouteEnum.BidGroupId]: GenericEnum.InitialFilterValue,
        [CreateEditTruckRouteEnum.ItemGroup]: GenericEnum.InitialFilterValue,
        [CreateEditTruckRouteEnum.VendorId]: GenericEnum.InitialFilterValue,
        [CreateEditTruckRouteEnum.StorageLocationId]:
          GenericEnum.InitialFilterValue,
        [CreateEditTruckRouteEnum.AccountCategory]:
          GenericEnum.InitialFilterValue,
        [CreateEditTruckRouteEnum.RouteName]: '',
        [CreateEditTruckRouteEnum.SiteIds]: [],
        [CreateEditTruckRouteEnum.ItemIds]: [],
        [CreateEditTruckRouteEnum.VendorIds]: [],
        [CreateEditTruckRouteEnum.Type]: TruckRouteTypeEnum.Delivery,
        [CreateEditTruckRouteEnum.AssignType]: AssignTypeEnum.Sites,
      };
      render = true;
    } else if (
      selectedTruckRouteDetail &&
      isNewEdit === CreateEditPageEnum.EDIT
    ) {
      initialValues = {
        [CreateEditTruckRouteEnum.SiteGroupId]: GenericEnum.InitialFilterValue,
        [CreateEditTruckRouteEnum.BidGroupId]: GenericEnum.InitialFilterValue,
        [CreateEditTruckRouteEnum.ItemGroup]: GenericEnum.InitialFilterValue,
        [CreateEditTruckRouteEnum.VendorId]: GenericEnum.InitialFilterValue,
        [CreateEditTruckRouteEnum.StorageLocationId]:
          GenericEnum.InitialFilterValue,
        [CreateEditTruckRouteEnum.AccountCategory]:
          GenericEnum.InitialFilterValue,
        [CreateEditTruckRouteEnum.RouteName]:
          selectedTruckRouteDetail[CreateEditTruckRouteEnum.RouteName],
        [CreateEditTruckRouteEnum.SiteIds]:
          selectedTruckRouteDetail[CreateEditTruckRouteEnum.SiteIds],
        [CreateEditTruckRouteEnum.ItemIds]:
          selectedTruckRouteDetail[CreateEditTruckRouteEnum.ItemIds],
        [CreateEditTruckRouteEnum.VendorIds]:
          selectedTruckRouteDetail[CreateEditTruckRouteEnum.DistributorIds],
        [CreateEditTruckRouteEnum.Type]:
          selectedTruckRouteDetail[CreateEditTruckRouteEnum.Type],
        [CreateEditTruckRouteEnum.AssignType]:
          selectedTruckRouteDetail[CreateEditTruckRouteEnum.AssignmentType],
      };
      routeName = selectedTruckRouteDetail[CreateEditTruckRouteEnum.RouteName];
      render = true;
    }
    return render ? (
      <CreateEditTruckRoute
        getBreadCrumbs={this.getBreadCrumbs}
        bidGroupOptions={bidGroupData}
        itemGroupOptions={itemGroupData}
        acctCategoryOptions={acctCategoryData}
        vendorDataOptions={vendorData}
        storageLocationDataOptions={storageLocationData}
        siteGroupDataOptions={siteGroupData}
        fetchingDropdown={fetchingDropdown}
        siteData={siteData}
        initialSelectedSites={initialSelectedSites}
        initialSelectedVendors={initialSelectedVendors}
        siteItems={siteItems}
        siteItemsLoading={siteItemsLoading}
        getMainProps={this.getMainProps}
        initialValues={initialValues}
        onSubmit={this.handleSubmit}
        saving={saving}
        selectedTruckRouteDetailLoading={selectedTruckRouteDetailLoading}
        routeName={routeName}
        isNew={isNewEdit === CreateEditPageEnum.NEW}
        id={id}
        truckRouteType={truckRouteType}
        assignType={assignType}
        vendorTableData={vendorTableData}
        vendorItemIdsLoading={vendorItemIdsLoading}
        clearSiteItems={clearSiteItems}
        vendorTableDataLoading={vendorTableDataLoading}
        truckRouteAssignmentTypesOptions={truckRouteAssignmentTypesOptions}
        truckRouteTypesOption={truckRouteTypesOption}
      />
    ) : null;
  };
  render() {
    const {
      saving,
      selectedTruckRouteDetailLoading,
      truckRouteAssignmentTypesLoading,
      truckRouteTypesLoading,
    } = this.props;
    return saving ||
      selectedTruckRouteDetailLoading ||
      truckRouteAssignmentTypesLoading ||
      truckRouteTypesLoading ? (
      <LoadingPage />
    ) : (
      this.getCreateEditTruckRoute()
    );
  }
}
const formSelector = formValueSelector(CREATE_EDIT_TRUCK_ROUTE_FORM_NAME);
const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(
    getIsDirty(CREATE_EDIT_TRUCK_ROUTE_FORM_NAME)(state)
  );

  return {
    isDirty: getIsDirty()(state),
    fetchingDropdown:
      FilterSelector.getBidGroupDataLoading(state) ||
      FilterSelector.getItemGroupDataLoading(state) ||
      FilterSelector.getAcctCategoryDataLoading(state) ||
      FilterSelector.getVendorDataLoading(state) ||
      FilterSelector.getStorageLocationDataLoading(state) ||
      FilterSelector.getSiteGroupDataLoading(state),
    bidGroupData: FilterSelector.selectBidGroupData(state),
    itemGroupData: FilterSelector.selectItemGroupData(state),
    acctCategoryData: FilterSelector.selectAcctCategoryData(state),
    vendorData: FilterSelector.selectVendorData(state),
    storageLocationData: FilterSelector.selectStorageLocationData(state),
    siteGroupData: FilterSelector.getSiteGroupDataWithAll(state),
    bidGroupDataError: FilterSelector.getBidGroupDataError(state),
    itemGroupDataError: FilterSelector.getItemGroupDataError(state),
    acctCategoryDataError: FilterSelector.getAcctCategoryDataError(state),
    vendorDataError: FilterSelector.getVendorDataError(state),
    storageLocationDataError: FilterSelector.getStorageLocationDataError(state),
    siteGroupLoadingError: FilterSelector.getSiteGroupDataError(state),
    siteData: Selectors.getRearrangedSites(state),
    siteItems: Selectors.getGroupedSiteItemIds(state),
    siteItemsMessage: Selectors.getSiteItemsMessage(state),
    siteItemsLoading: Selectors.getSiteItemIdsLoading(state),
    siteItemsLoadingError: Selectors.getSiteItemIdsLoadingError(state),
    initialSelectedSites: Selectors.getSelectedSites(state),
    initialSelectedVendors: Selectors.getSelectedVendors(state),
    saving: Selectors.getSaveLoading(state),
    saveError: Selectors.getSaveLoadingError(state),
    saved: Selectors.getSaveData(state),
    selectedTruckRouteDetailLoading: Selectors.getSelectedTruckRouteDetailLoading(
      state
    ),
    selectedTruckRouteDetail: Selectors.getSelectedTruckRouteDetail(state),
    selectedTruckRouteDetailError: Selectors.getSelectedTruckRouteDetailError(
      state
    ),
    truckRouteType: formSelector(state, CreateEditTruckRouteEnum.Type),
    assignType: formSelector(state, CreateEditTruckRouteEnum.AssignType),
    vendorTableData: Selectors.getRearrangedVendors(state),
    vendorTableDataLoading: FilterSelector.getVendorDataLoading(state),
    vendorItemIdsLoading: Selectors.getVendorItemIdsLoading(state),
    vendorItemIdsLoadingError: Selectors.getVendorItemIdsLoadingError(state),
    truckRouteAssignmentTypesLoading: Selectors.getTruckRouteAssignmentTypesLoading(
      state
    ),
    truckRouteAssignmentTypesLoadingError: Selectors.getTruckRouteAssignmentTypesLoadingError(
      state
    ),
    truckRouteAssignmentTypesOptions: Selectors.selectTruckRouteAssignmentTypes(
      state
    ),
    truckRouteTypesLoading: Selectors.getTruckRouteTypesLoading(state),
    truckRouteTypesLoadingError: Selectors.getTruckRouteTypesLoadingError(
      state
    ),
    truckRouteTypesOption: Selectors.selectTruckRouteTypes(state),
  };
};

const mapDispatchToProps = {
  clearFilterErrorMsg,
  resetDirty,
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getAcctCategoryForCurrentSite,
  getVendorForCurrentSite,
  getStorageLocationForCurrentSite,
  getSiteGroupDataForCurrentSite,
  getSitesAction,
  getSiteItemsBySiteIds,
  submitForm,
  clearErrors,
  saveTruckRoute,
  resetForm,
  clearSiteItems,
  clearSavedMessage,
  getTruckRouteById,
  clearSiteItemsMessage,
  setNotificationDialog,
  getItemsByDistributorIds,
  getTruckRouteAssignmentTypes,
  getTruckRouteTypes,
};

export const CreateEditTruckRoutePage = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateEditTruckRoutePageContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/subpages/CreateEditTruckRoutePage.js